/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_ThemeInputs */

const es_sidebar_theme = /** @type {(inputs: Sidebar_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar tema`)
};

const en_sidebar_theme = /** @type {(inputs: Sidebar_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle theme`)
};

/**
* | output |
* | --- |
* | "Toggle theme" |
*
* @param {Sidebar_ThemeInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const sidebar_theme = /** @type {((inputs?: Sidebar_ThemeInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_ThemeInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_sidebar_theme(inputs)
	return en_sidebar_theme(inputs)
});
export { sidebar_theme as "sidebar.theme" }